<template>
  <div v-if="showActionsDropdown" class="conversation-user-actions--container">
    <dropdown v-model="isWindowOptionsOpen" menu-right>
      <button class="conversation-user-actions">
        <span>...</span>
      </button>

      <template slot="dropdown">
        <li v-if="canMinimize">
          <a class="user-action--item" role="button" @click="handleMinimize">
            <span
              class="user-action--item--icon"
              :style="`color: rgba(${settings.bgColorRGBA});`"
            >
              <svg width="13.39" height="13.39" viewBox="0 0 13.39 13.39">
                <use xlink:href="#icon--chat--minimize"></use>
              </svg>
            </span>
            {{ $t('conversation.header.minimize') }}
          </a>
        </li>

        <li v-if="canCloseConversation" role="separator" class="divider"></li>

        <li>
          <a
            v-if="canCloseConversation"
            class="user-action--item"
            role="button"
            @click="closeConverstionHandler"
          >
            <span
              class="user-action--item--icon"
              :style="`color: rgba(${settings.bgColorRGBA});`"
            >
              <svg width="14" height="14" viewBox="0 0 14 14">
                <use xlink:href="#icon--chat--close"></use>
              </svg>
            </span>
            {{ $t('conversation.header.endConversation') }}
          </a>
        </li>
      </template>
    </dropdown>

    <ConversationHeaderCloseConfirmation
      v-if="showConversationCloseConfirmation"
      @close="showConversationCloseConfirmation = false"
    />
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { roomStatus } from '@/helpers'

  import services from '@/services'

  import ConversationHeaderCloseConfirmation from './ConversationHeaderCloseConfirmation'

  export default {
    components: {
      ConversationHeaderCloseConfirmation
    },
    data() {
      return {
        showConversationCloseConfirmation: false,
        isWindowOptionsOpen: false
      }
    },
    computed: {
      ...mapGetters([
        'settings',
        'closingChatLoader',
        'chatStatus',
        'isPopup',
        'inBotConversation',
        'conversationClosed',
        'creatingChat'
      ]),
      canMinimize() {
        return !this.isPopup
      },
      canCloseConversation() {
        if (
          (!this.conversationClosed || this.creatingChat) &&
          this.settings.conversation.clientCanClose
        )
          return true

        return (
          this.settings.conversation.clientCanClose &&
          this.chatStatus !== roomStatus.closed &&
          !this.closingChatLoader
        )
      },
      showActionsDropdown() {
        return this.canMinimize || this.canCloseConversation
      }
    },
    watch: {
      isWindowOptionsOpen(open) {
        this.setOverlayOpen(open)
      },
      showConversationCloseConfirmation(open) {
        this.setOverlayOpen(open)
      }
    },
    methods: {
      ...mapActions(['toggleApp', 'setOverlayOpen']),
      closeConverstionHandler() {
        this.showConversationCloseConfirmation = true

        setTimeout(() => {
          this.setOverlayOpen(true)
        }, 0)
      },
      handleMinimize() {
        this.toggleApp()

        services.iframe.postMessage({
          name: 'analytics',
          type: 'woz test widget minimize widget'
        })
      }
    }
  }
</script>

<style>
  .conversation-user-actions--container {
    position: absolute;
    top: 0px;
    right: 13px;
  }

  .conversation-user-actions {
    width: 24px;
    height: 24px;
    font-size: 22px;
    border: none;
    background: transparent;
    cursor: pointer;
  }

  .user-action--item {
    background: transparent;
    opacity: 0.44;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    cursor: pointer;
    padding: 0.5rem;
    color: #666666 !important;
    display: flex !important;
  }

  .user-action--item--icon {
    margin-right: 0.5rem;
    display: flex;
    align-items: center;
  }
</style>
